<template>
  <div>
    <ContainerComponent />
    <div class="content-page">
      <div>
        <div class="actions-left">
          <div>
            <div v-if="!show" class="header" @click="show = !show">
              <i class="navigation-toggle"></i>
            </div>
          </div>
          <div v-if="show" class="header" @click="show = !show">
            <i class="navigation-toggle closed"></i>
            <label class="item">Menu</label>
          </div>
        </div>
        <div></div>
        <transition appear name="fade">
          <div class="nav-content" v-if="show">
            <div class="tile sm-2">
              <div class="content">
                <div
                  class="content-item pointer"
                  v-for="item in menuItems"
                  :key="item.name"
                  @click="selectedView(item.name)">
                  {{ item.label }}
                </div>
              </div>
              <div class="user-guide-link pointer">
                <a :href="guideLink" target="_blank">User guide</a>
              </div>
            </div>
          </div>
        </transition>
      </div>
      <div class="left-content">
        <ProductListComponent v-if="menuItemName === 'admin'" />
        <AssetsComponentVue v-if="menuItemName === 'assets'" />
        <AssetMwcComponent v-if="menuItemName === 'mwc'" />
        <FamilyAdminPage v-if="menuItemName === 'family-admin'" />
        <PagesComponent v-if="menuItemName === 'pages'" />
      </div>
    </div>
  </div>
</template>

<script>
import ContainerComponent from '../components/ContainerComponent.vue';
import ProductListComponent from '../components/complex.component/ProductListComponent.vue';
import AssetsComponentVue from '../components/complex.component/AssetsComponent.vue';
import FamilyAdminPage from '../views/FamilyAdminPage.vue';
import AssetsApiService from '@/services/assetsServices/assetsApiService';
import { DEFAULT_ASSETS_TYPE } from '@/constants/assets';
import AssetMwcComponent from '@/components/complex.component/AssetMwcComponent.vue';
import AssetsMwcApiService from '@/services/assetsMwcServices/assetsMwcApiService';
import FamilyPreviewApiService from '@/services/familyPreviewServices/familyPreviewApiService';
import ProductApiService from '@/services/productApiService';
import { USER_GUIDE } from '@/constants/routes';
import PagesComponent from '@/components/complex.component/PagesComponent.vue';

export default {
  name: 'MainPageComponent',
  components: {
    ContainerComponent,
    ProductListComponent,
    AssetsComponentVue,
    FamilyAdminPage,
    AssetMwcComponent,
    PagesComponent
  },

  async created() {
    await this.initData();
  },

  watch: {
    menuItemName: async function () {
      await AssetsApiService.getAssetsByType({
        assetsType: DEFAULT_ASSETS_TYPE,
      });
      await AssetsApiService.getAssets();
    },
  },

  data() {
    return {
      text: '',
      selected: '',
      show: false,
      menuItems: [
        {
          name: 'admin',
          label: 'Products',
        },
        {
          name: 'assets',
          label: 'Assets',
        },
        {
          name: 'family-admin',
          label: 'Family',
        },
        {
          name: 'mwc',
          label: 'MWC',
        },
        {
          name: 'pages',
          label: 'Pages',
        }
      ],
      menuItemName: 'admin',
      guideLink: USER_GUIDE.link
    };
  },

  methods: {
    selectedView(item) {
      this.menuItemName = item;
      this.show = false;
    },

    async initData() {
      await ProductApiService.getProductFamilies();
      await AssetsApiService.getAssetsByType({ assetsType: DEFAULT_ASSETS_TYPE });
      await AssetsApiService.getAssets();
      await AssetsMwcApiService.getAssetsMwc();
      await FamilyPreviewApiService.getAllFamilyPreview();
      await ProductApiService.get();
    }
  },
};
</script>

<style lang="less" scoped>
@import '~@eds/vanilla/variables/global.less';
@import '~@eds/vanilla/variables/dark.less';

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0s ease-out forward;
}

.fade-enter,
.fade-leave-to {
  opacity: 0s;
}

.fade-enter-active {
  transition: opacity 0s;
}

.icon {
  color: @blue-43;
}

.pointer {
  cursor: pointer;
  //   margin-bottom: 10px;
  padding: 10px 10px 10px 20px;
}

.content-item {
  padding-left: 2rem;
}

.content-item:hover {
  background-color: @blue-43;
}

.heder-content {
  padding: 0px 0px 0px 10px;
}

/* .content-element {
    margin-left: 50px;
} */

.navigation-toggle {
  top: 0;
}

.actions-left {
  display: inline-block;
  vertical-align: middle;
  padding: 1rem;
  width: fit-content;
  position: fixed;
}

.content {
  margin-top: 2rem;
}

.header {
  display: flex;
}

.item {
  margin-left: 1rem;
}

.nav-content {
  width: 15rem;
  height: 100vh;
}

.tile {
  height: inherit;
}

.content-page {
  display: flex;
}

.left-content {
  // margin-top: 1rem;
  margin-left: 2.5rem;
  overflow: scroll;
  height: 100vh;
  width: 100%;
  padding-bottom: 2rem;
}

.user-guide-link {
  position: fixed;
  bottom: 0;
  padding-left: 2rem;
  margin-bottom: 2rem;
}
</style>